export default "/_next/static/assets/iah-phone-mask_74aa6784aaf96eb55f442168cd96a013.png";